import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=a5bfe790&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./_id.vue?vue&type=style&index=1&id=a5bfe790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bfe790",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/builds/master/frontend/frontend-universe/components/avatar.vue').default,SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
